import React from 'react'

import ResourceStrip from './cards/resource-strip'
import { useStaticQuery, graphql } from 'gatsby'

const ResourcesBlock = ({ resources = null }) => {

  const settings = useStaticQuery(graphql`
    query formSettings {
      wp {
        siteOptions {
          acf {
           brochureFormId
           brochureFormText
          }
        }
      }
    }
  `)

  const { brochureFormId, brochureFormText } = settings.wp.siteOptions.acf

  return (
    <section className='resources-block'>
      <div className='resources-block__inner'>
        {resources?.length > 0 &&
          <div className='post__resources'>
            <h3>Resources</h3>
            <div className='post__resources-list'>
              {resources.map((el, i) => (
                <ResourceStrip {...el} key={i} brochureFormText={brochureFormText} brochureFormId={brochureFormId || 329} />
              ))}
            </div>
          </div>
        }
      </div>
    </section>
  )
}

export default ResourcesBlock